// #ifdef H5
// 修复 PDA 老旧浏览器不支持 Array.prototype.flat 的问题
if (!Array.prototype.flat) {
  Array.prototype.flat = function (depth) {
    var flattend = [];
    (function flat(array: any, depth) {
      for (var i = 0; i < array.length; i++) {
        if (Array.isArray(array[i]) && depth > 0) {
          flat(array[i], depth - 1);
        } else {
          flattend.push(array[i]);
        }
      }
    })(this, Math.floor(depth) || 1);
    return flattend;
  };
}
// #endif
